import { render, staticRenderFns } from "./ExpensesAdd.vue?vue&type=template&id=1673ed7c&scoped=true&"
import script from "./ExpensesAdd.vue?vue&type=script&lang=js&"
export * from "./ExpensesAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesAdd.vue?vue&type=style&index=0&id=1673ed7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673ed7c",
  null
  
)

export default component.exports